export class EntLocation {
  name: string;
  timezone: string;

  constructor(name: string, timezone: string) {
    this.name = name;
    this.timezone = timezone;
  }
}
